import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";

const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    ta.remove();
  }
};

export const CopyText = ({ value, label = "Teks", className = "", testid, children }) => {
  const [done, setDone] = useState(false);
  const copy = async (e) => {
    e.stopPropagation();
    if (!value) return;
    await copyToClipboard(String(value));
    setDone(true);
    toast.success(`${label} ${value} disalin`);
    setTimeout(() => setDone(false), 1400);
  };
  return (
    <span onDoubleClick={copy} title="Klik 2x untuk menyalin" className={`group relative inline-flex cursor-copy select-all items-center pr-5 ${className}`} data-testid={testid}>
      {children ?? value}
      <button type="button" onClick={copy} aria-label={`Salin ${label}`} data-testid={testid ? `${testid}-copy` : undefined}
        className={`absolute -right-0.5 -top-1.5 rounded-md p-1 transition-colors ${done ? "text-emerald-400" : "text-zinc-500 hover:bg-white/10 hover:text-[#e5b80b]"}`}>
        {done ? <Check size={11} /> : <Copy size={11} />}
      </button>
    </span>
  );
};
